/**
 * Recognised Leanpub/Markua callout (aside) types.
 *
 * MUST stay in sync with the server's canonical list in
 * api/src/utils/tiptap/tiptapContent.ts (`CALLOUT_TYPES`). A drift guard test
 * (api/src/utils/tiptap/__tests__/tiptapContent.test.js) reads this file as
 * text and fails if the two lists diverge — the same cross-app text-compare
 * pattern used for feature flags.
 *
 * This module deliberately imports nothing from tiptap/@fortawesome so it can
 * be required from jest (which does not transform those ESM packages), exactly
 * like sceneCommentMapping.js.
 */
export const CALLOUT_TYPES = ['aside', 'blurb', 'note', 'warning', 'tip'];
